import React, { useEffect, useState } from "react";
import config from "lib/fr-config";
// import TXT from "presentational/common/multinational/TXT";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";

const fontCss = config.css.fontThickness;

const BombTypography = withStyles({
  root: {
    fontSize: 16,
    fontWeight: fontCss.medium,
    lineHeight: 1
  }
})(Typography);
const BombTypographySM = withStyles({
  root: {
    fontSize: 14,
    fontWeight: fontCss.medium,
    lineHeight: 1
  }
})(Typography);

BombCountdownView.propTypes = {
  isoDateStr: PropTypes.string.isRequired,
  sizeType: PropTypes.oneOf(["default", "sm"]),
  onCountdownEnd: PropTypes.func
};

BombCountdownView.defaultProps = {
  sizeType: "default",
  onCountdownEnd: () => {}
};

function BombCountdownView(props) {
  const { isoDateStr, sizeType, onCountdownEnd } = props;

  const [intervalId, setIntervalId] = useState(null);
  const [countDownDay, setCountDownDay] = useState("00");
  const [countDownHour, setCountDownHour] = useState("00");
  const [countDownMin, setCountDownMin] = useState("00");
  const [countDownSec, setCountDownSec] = useState("00");
  const [hasTimerEnd, setHasTimerEnd] = useState(false);

  useEffect(() => {
    initCountDown();
  }, []);
  useEffect(() => {
    return () => {
      endCountDown();
    };
  }, [intervalId]);
  useEffect(() => {
    if (hasTimerEnd) {
      endCountDown();
      onCountdownEnd();
    }
  }, [hasTimerEnd]);

  const initCountDown = () => {
    setCountDownNumbers();

    const intervalId = setInterval(() => {
      setCountDownNumbers();
    }, 1000);

    setIntervalId(intervalId);
  };

  const endCountDown = () => {
    if (typeof intervalId !== "number") return null;
    clearInterval(intervalId);
  };

  const setCountDownNumbers = () => {
    const now = new Date();

    const futureTime = new Date(isoDateStr);

    const diffMs = futureTime - now;

    const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diffMs % (1000 * 60)) / 1000);

    if (diffMs < 0) {
      setHasTimerEnd(true);
    } else {
      setCountDownDay(days.toString().padStart(2, "0"));
      setCountDownHour(hours.toString().padStart(2, "0"));
      setCountDownMin(minutes.toString().padStart(2, "0"));
      setCountDownSec(seconds.toString().padStart(2, "0"));
    }
  };

  const getFullText = () => {
    return `${countDownDay} : ${countDownHour} : ${countDownMin} : ${countDownSec}`;
  };

  return hasTimerEnd ? null : sizeType === "sm" ? (
    <BombTypographySM>{getFullText()}</BombTypographySM>
  ) : (
    <BombTypography>{getFullText()}</BombTypography>
  );
}

export default BombCountdownView;
